import React from "react";
import {
  CircularProgress
} from "@material-ui/core";

function Loader(props) {
  return (
    <div className="page-loader-class">
      <CircularProgress
        size={props.size}
        color="primary"
      ></CircularProgress>
    </div>
  );
}

export default Loader;
